import { number, object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';
import { getMinMaxGroupTilt } from 'common/utils/helpers/systemsValues';

import {
    getCommonFieldsValidationSchema,
    getExtraFieldsValidationSchema,
} from './validateCommonFields';

export default (values) => {
    const {
        NUMBER_TYPE_TEXT,
        REQUIRED_TEXT,
        getMinValueText,
        getMaxValueText,
    } = getValidationTexts();

    const { system_uid } = values;

    const rooftTab = {
        name: string().required(REQUIRED_TEXT).nullable(),
        safe_zone: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(0, getMinValueText(0))
            .nullable(),
    };

    const moduleTab = {
        azimuth: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(0, getMinValueText(0))
            .max(360, getMaxValueText(360))
            .nullable(),
        panel: object({
            height: number()
                .typeError(NUMBER_TYPE_TEXT)
                .required(REQUIRED_TEXT)
                .min(0, getMinValueText(0))
                .nullable(),
            depth: number()
                .typeError(NUMBER_TYPE_TEXT)
                .required(REQUIRED_TEXT)
                .min(30, getMinValueText(30))
                .max(40, getMinValueText(40))
                .nullable(),
            watts: number()
                .typeError(NUMBER_TYPE_TEXT)
                .required(REQUIRED_TEXT)
                .min(0, getMinValueText(0))
                .nullable(),
            weight: number()
                .typeError(NUMBER_TYPE_TEXT)
                .required(REQUIRED_TEXT)
                .min(0, getMinValueText(0))
                .nullable(),
            width: number()
                .typeError(NUMBER_TYPE_TEXT)
                .required(REQUIRED_TEXT)
                .min(0, getMinValueText(0))
                .nullable(),
        }),
        solar_module: string().when(
            'is_custom_module',
            ([is_custom_module], schema) => {
                if (is_custom_module) return schema.nullable();
                return schema.required(REQUIRED_TEXT).nullable();
            },
        ),
    };

    const [minTilt, maxTilt] = getMinMaxGroupTilt(system_uid);

    const groupTab = {
        tilt: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(minTilt, getMinValueText(minTilt))
            .max(maxTilt, getMaxValueText(maxTilt))
            .nullable(),
    };

    let otherValidations = {};

    const shape = {
        ...rooftTab,
        ...moduleTab,
        ...groupTab,
        ...getCommonFieldsValidationSchema(values),
        ...getExtraFieldsValidationSchema(values),
        ...otherValidations,
    };

    return object().shape(shape);
};
